"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let EntityEvents = class EntityEvents extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    entityId;
    onEntity_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("entityId");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    selectedEventId;
    eventData;
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('list_entity_events', { parameters: { id: this.entityId } });
    }
    ux;
    b_7315092382398562_noHeader;
    b_7315092382398562_modalBindings;
    b_7789867021953041_headerShowColumnSelectorButton;
    b_7789867021953041_headerShowReloadButton;
    b_7789867021953041_columns;
    b_2070266589801014_options;
    dataMembers = ['selectedEventId', 'eventData', 'ds', 'ux', 'b_7315092382398562_noHeader', 'b_7315092382398562_modalBindings', 'b_7789867021953041_headerShowColumnSelectorButton', 'b_7789867021953041_headerShowReloadButton', 'b_7789867021953041_columns', 'b_2070266589801014_options'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                selectedEventId: null,
                eventData: null,
                ds: null,
                ux: null,
                b_7315092382398562_noHeader: false,
                b_7315092382398562_modalBindings: {
                    noHeader: false,
                    noPrimaryButton: true,
                    size: "full-screen",
                },
                b_7789867021953041_headerShowColumnSelectorButton: false,
                b_7789867021953041_headerShowReloadButton: false,
                b_7789867021953041_columns: [{
                        field: "event_name",
                        name: this.$fn.pgettext("EntityEvents", "Event"),
                        type: "command",
                    },
                    {
                        field: "timestamp",
                        name: this.$fn.pgettext("EntityEvents", "Timestamp"),
                        formatter: {
                            name: "datetime",
                        },
                    },
                    {
                        field: "identity",
                        name: this.$fn.pgettext("EntityEvents", "User"),
                        formatter: {
                            name: "user",
                        },
                    },
                ],
                b_2070266589801014_options: {
                    lineNumbers: true,
                    matchBrackets: true,
                    continueComments: "Enter",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("EntityEvents/header", "Entity events"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_2470_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_7789867021953041_setData_2474_getActionArgs($event) {
        return {
            path: "selectedEventId",
            value: $event.data.data.id,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_7789867021953041_setData_2478_getActionArgs($event) {
        return {
            path: "eventData",
            value: JSON.stringify($event.data.response.data, null, 2),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_7789867021953041_request_2476_getActionArgs($event) {
        return {
            operation: "read_entity_event_data",
            data: { id: this.entityId, event_id: this.selectedEventId },
        };
    }
    async evh_7789867021953041_commandEventName(event, scope) {
        return await this.actions.evh_7789867021953041_commandEventName.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_2470 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_2470_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_2469 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_2470,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_2469],
        });
        const act_2248226175642056_closeModal_2472 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_2248226175642056_close_2471 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeModal_2472,
            event: "close",
            displayName: "closeModal",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_2471],
        });
        const act_7789867021953041_setData_2474 = new core_1.actions.SetDataAction({
            actionArgs: this.act_7789867021953041_setData_2474_getActionArgs,
            events: [],
        });
        const evh_7789867021953041_commandEventName_2473 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_setData_2474,
            event: "command:event_name",
            displayName: "setData",
        });
        const act_7789867021953041_setData_2478 = new core_1.actions.SetDataAction({
            actionArgs: this.act_7789867021953041_setData_2478_getActionArgs,
            events: [],
        });
        const evh_7789867021953041_success_2477 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_setData_2478,
            event: "success",
            displayName: "setData",
        });
        const act_7789867021953041_request_2476 = new core_1.actions.RequestAction({
            actionArgs: this.act_7789867021953041_request_2476_getActionArgs,
            displayName: "loadEventData",
            events: [evh_7789867021953041_success_2477],
        });
        const evh_7789867021953041_commandEventName_2475 = new core_1.actions.EventHandlerImpl({
            action: act_7789867021953041_request_2476,
            event: "command:event_name",
            displayName: "loadEventData",
        });
        const evh_7789867021953041_commandEventName = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7789867021953041_commandEventName_2473, evh_7789867021953041_commandEventName_2475],
        });
        return {
            act_7315092382398562_closeModal_2470,
            evh_7315092382398562_close_2469,
            evh_7315092382398562_close,
            act_2248226175642056_closeModal_2472,
            evh_2248226175642056_close_2471,
            evh_2248226175642056_close,
            act_7789867021953041_setData_2474,
            evh_7789867021953041_commandEventName_2473,
            act_7789867021953041_setData_2478,
            evh_7789867021953041_success_2477,
            act_7789867021953041_request_2476,
            evh_7789867021953041_commandEventName_2475,
            evh_7789867021953041_commandEventName,
            loadEventData: act_7789867021953041_request_2476,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: String,
    }),
    __metadata("design:type", String)
], EntityEvents.prototype, "entityId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('entityId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], EntityEvents.prototype, "onEntity_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "full-screen",
    }),
    __metadata("design:type", String)
], EntityEvents.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], EntityEvents.prototype, "onSize", null);
EntityEvents = __decorate([
    (0, vue_property_decorator_1.Component)()
], EntityEvents);
exports.default = EntityEvents;
vue_property_decorator_1.Vue.component("EntityEvents", EntityEvents);
